import { render } from "./AdminTopBannerView.vue?vue&type=template&id=20cd0184&scoped=true"
import script from "./AdminTopBannerView.vue?vue&type=script&lang=js"
export * from "./AdminTopBannerView.vue?vue&type=script&lang=js"

import "./AdminTopBannerView.vue?vue&type=style&index=0&id=20cd0184&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20cd0184"]])

export default __exports__